export default __webpack_public_path__ + "static/media/esirsLogo.c4ff5d99.png";